import { createInstance, i18n as I18Next, TFunction as TFunctionNext } from 'i18next';
import { initReactI18next } from 'react-i18next/initReactI18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { i18nConfig } from 'i18n-config';

export type TFunction = TFunctionNext;

export default async function initTranslations(
  locale: Locale,
  namespace: string,
  i18nInstance?: I18Next,
) {
  const instance = i18nInstance || createInstance();

  instance.use(initReactI18next);

  instance.use(
    resourcesToBackend(
      (lng: string, ns: string) => import(`../public/locales/${lng}/${ns}.json`),
    ),
  );

  await instance.init({
    debug: false,
    lng: locale,
    fallbackLng: i18nConfig.defaultLocale,
    supportedLngs: i18nConfig.locales,
    defaultNS: namespace,
    fallbackNS: namespace,
    ns: namespace,
    preload: i18nConfig.locales,
  });

  return instance;
}

export async function getServerSideTranslation(locale: Locale, namespace: string) {
  const i18nextInstance = await initTranslations(locale, namespace);

  return {
    t: i18nextInstance.getFixedT(locale, namespace),
    i18n: i18nextInstance,
  };
}
